<template>
	<div class="col" gutter="20">
		<Title title="學校單位管理" />
		<SearchBar :searchText="searchText" @search="handleSearch" placeholder="縣市、區域、名稱" />

		<div class="row" align-x="between" align-y="center">
			<div class="row" align-y="center" gutter="20">
				<el-button @click="openDialog()" type="primary" icon="el-icon-plus" size="mini">新增單位</el-button>
				<el-radio-group v-model="activated" @change="statusChange" size="mini">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button label="true">啟用</el-radio-button>
					<el-radio-button label="false">隱藏</el-radio-button>
				</el-radio-group>
				<el-radio-group v-model="category" @change="statusChange" size="mini">
					<el-radio-button label="">全部</el-radio-button>
					<el-radio-button :label="1">國小</el-radio-button>
					<el-radio-button :label="2">國中</el-radio-button>
					<el-radio-button :label="3">高中</el-radio-button>
				</el-radio-group>
			</div>
			<el-pagination v-if="dataList.total > 0" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10, 30, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="dataList.total" />
		</div>

		<el-table :data="dataList.list">
			<el-table-column label="縣市" prop="city"></el-table-column>
			<el-table-column label="區域" prop="district"></el-table-column>
			<el-table-column label="名稱" prop="name"></el-table-column>
			<el-table-column label="地址" prop="address"></el-table-column>
			<el-table-column label="狀態" align="center">
				<template slot-scope="{row}">
					<el-tag :type="row.activated ? 'success' : 'info'">
						{{row.activated ? '顯示' : '隱藏'}}
					</el-tag>
				</template>
			</el-table-column>
			<el-table-column label="操作">
				<template slot-scope="{row}">
					<el-button @click="openDialog(row)" type="text">編輯</el-button>
					<el-button @click="handleDatete(row.id)" icon="el-icon-delete" type="text" class="color-danger"></el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog title="新增單位" :visible.sync="dialogVisible" @close="closeDialog()" :close-on-click-modal="false" :close-on-press-escape="false">
			<el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-position="left" label-width="80px">
				<el-form-item label="縣市">
					<div class="row" gutter="20">
						<el-form-item prop="city">
							<el-select v-model="ruleForm.city">
								<el-option v-for="(city, i) in cityList" :key="i" :value="city">{{city}}</el-option>
							</el-select>
						</el-form-item>
						<el-form-item prop="district">
							<el-select v-model="ruleForm.district">
								<el-option v-for="(district, i) in districtList" :key="i" :value="district">{{district}}</el-option>
							</el-select>
						</el-form-item>
					</div>
				</el-form-item>
				<el-form-item label="學校種類" prop="category">
					<el-radio-group v-model="ruleForm.category" @change="statusChange" size="mini">
						<el-radio-button :label="1">國小</el-radio-button>
						<el-radio-button :label="2">國中</el-radio-button>
						<el-radio-button :label="3">高中</el-radio-button>
					</el-radio-group>
				</el-form-item>
				<el-form-item label="單位名稱" prop="name">
					<el-input v-model="ruleForm.name"></el-input>
				</el-form-item>
				<el-form-item label="地址">
					<el-row type="flex" :gutter="20">
						<el-col :span="5">
							<el-form-item prop="code">
								<el-input v-model="ruleForm.code" type="number" placeholder="郵遞區號"></el-input>
							</el-form-item>
						</el-col>
						<el-col>
							<el-form-item prop="address">
								<el-input v-model="ruleForm.address" placeholder="地址"></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form-item>
				<el-form-item label="是否顯示" prop="activated">
					<el-switch v-model="ruleForm.activated" active-text="顯示"></el-switch>
				</el-form-item>
				<el-form-item>
					<div class="row" align-x="right">
						<el-button type="info" @click="closeDialog()">取消</el-button>
						<el-button type="primary" @click="handleSubmit()">{{isNewPost ? '新增' : '更新'}}</el-button>
					</div>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
import Title from "@/components/backendManage/Title";
import SearchBar from "@/components/backendManage/SearchBar";
import { mapActions, mapState } from "vuex";
import API from "@/api";
import _ from "lodash";
import moment from "moment-timezone";
import cityData from "@/data/city.json";

function fields() {
	return {
		city: '',
		district: '',
		category: '',
		name: '',
		code: 100,
		address: '',
		activated: false
	}
}

export default {
	components: { Title, SearchBar },
	data() {
		return {
			isNewPost: true,
			dialogVisible: false,
			currentPage: 1,
			pageSize: 10,
			searchText: "",
			activated: '',	// 是否顯示
			category: '',	// 國小、國中、高中
			ruleForm: fields(),
			rules: {
				city: [{ required: true, message: '縣市', trigger: 'blur' }],
				district: [{ required: true, message: '地區', trigger: 'blur' }],
				category: [{ required: true, message: '學校種類', trigger: 'blur' }],
				name: [{ required: true, message: '單位名稱', trigger: 'blur' }],
				code: [{ required: true, message: '郵遞區號', trigger: 'blur' }],
				address: [{ required: true, message: '地址', trigger: 'blur' }],
				activated: [{ required: true, message: '是否顯示', trigger: 'blur' }]
			}
		};
	},
	computed: {
		...mapState('school', ['dataList']),
		query: {
			get() {
				return {
					page: this.currentPage,
					size: this.pageSize,
					text: this.searchText,
					activated: this.activated,
					category: this.category
				}
			},
			set({ page, size, text, activated, category }) {
				if (page) this.currentPage = Number(page);
				if (size) this.pageSize = Number(size);
				if (text) this.searchText = text;
				if (activated) this.activated = JSON.parse(activated);
				if (category) this.category = category;
			}
		},
		cityList() {
			return Object.keys(cityData) || [];
		},
		districtList() {
			return cityData[this.ruleForm.city] || [];
		}
	},
	watch: {
		async $route(val) {
			await this.getSchoolList(this.query);
		}
	},
	methods: {
		...mapActions('school', ['getSchoolList', 'createSchool', 'updateSchool', 'deleteSchool']),
		init() {
			if (this.$route.query) this.query = this.$route.query;
		},
		handleSearch(text) {
			this.searchText = text;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleSizeChange(size) {
			this.pageSize = size;
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		handleCurrentChange(page) {
			this.currentPage = page;
			this.$router.replace({ query: this.query });
		},
		statusChange(status) {
			this.currentPage = 1;
			this.$router.replace({ query: this.query });
		},
		resetForm() {
			this.$refs['ruleForm'].clearValidate();
			this.ruleForm = fields();
		},
		openDialog(data) {
			if (data) this.ruleForm = data;
			this.isNewPost = data ? false : true;
			this.dialogVisible = true;
		},
		closeDialog() {
			this.resetForm();
			this.dialogVisible = false;
		},
		handleSubmit() {
			this.$refs['ruleForm'].validate(async valid => {
				if (valid) {
					try {
						if (this.isNewPost) {
							await this.createSchool({ query: this.query, data: this.ruleForm });
						} else {
							await this.updateSchool({ query: this.query, data: this.ruleForm });
						}
						this.closeDialog();
					} catch (e) {
						this.$message.error(e);
					}
				}
			})
		},
		handleDatete(id) {
			this.$confirm('確定刪除？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				await this.deleteSchool({ query: this.query, id });
				this.$message({
					type: 'success',
					message: '删除成功！'
				});
			}).catch(() => { });
		}
	},
	async created() {
		this.init();
		await this.getSchoolList(this.query);
	}
};
</script>

<style lang="scss" scoped>
</style>